import React, { Fragment } from 'react';
import { FlexRow } from '../common/forms/FormElements';
import EquipmentJobAssignment from './EquipmentJobAssignment';

export default class DispatchJobEquipmentTypeAssignments
    extends React.Component
{
    renderHeader = () => (
        <FlexRow>
            <span
                style={{
                    marginTop: '6px',
                    marginBottom: '4px',
                    fontWeight: 'bold',
                    fontSize: '12px',
                    color: '#808080',
                }}
            >
                Unassigned Equipment:
            </span>
        </FlexRow>
    );

    isEquipmentAssignedToCrewEmployee = (requiredEquipmentType) => {
        const { job, dayInt } = this.props;

        if (
            !requiredEquipmentType.assignment ||
            !requiredEquipmentType.assignedEmployee
        ) {
            return false;
        }

        const staffIds = job.assignments[dayInt].staff.map(
            (s) => s.assignment?.id
        );

        return (
            requiredEquipmentType.assignment &&
            requiredEquipmentType.assignedEmployee &&
            staffIds.includes(requiredEquipmentType.assignedEmployee.id)
        );
    };

    render() {
        const { job, jobIndex, dayInt, day } = this.props;

        if (
            !job.assignments ||
            !job.assignments[dayInt] ||
            !job.assignments[dayInt].equipment ||
            !job.assignments[dayInt].equipment.length
        ) {
            return null;
        }

        let isFirst = false;

        return job.assignments[dayInt].equipment.map(
            (requiredEquipmentType, index) => {
                const key = `${jobIndex}_${dayInt}_equipment_${index}`;

                if (
                    this.isEquipmentAssignedToCrewEmployee(
                        requiredEquipmentType
                    )
                ) {
                    return <Fragment key={key}></Fragment>;
                }

                if (isFirst) {
                    isFirst = false;

                    return (
                        <Fragment key={key}>
                            {this.renderHeader()}
                            <EquipmentJobAssignment
                                key={key}
                                job={job}
                                jobIndex={jobIndex}
                                day={day}
                                dayAssignments={job.assignments[dayInt]}
                                assignmentIndex={index}
                                requiredEquipmentType={requiredEquipmentType}
                                {...this.props}
                            />
                        </Fragment>
                    );
                }

                return (
                    <EquipmentJobAssignment
                        key={key}
                        job={job}
                        jobIndex={jobIndex}
                        day={day}
                        dayAssignments={job.assignments[dayInt]}
                        assignmentIndex={index}
                        requiredEquipmentType={requiredEquipmentType}
                        {...this.props}
                    />
                );
            }
        );
    }
}
